export default __webpack_public_path__ + "static/media/icone-doc-assinado.f67e68a6.svg";